import autosize from 'autosize';
import { Tooltip } from "bootstrap";

//import '../old_js/misc/autonumeric_init.js'
//import '../old_js/misc/autonumeric.js'

// Run when DOM is ready
$(() => {
  console.log("pickers.ts");

  // Initialize clockpicker
  // $(".clockpicker").clockpicker();

  // Autosize textareas
  $(".autosizetext").each(function () {
    autosize(this);
  });

  // Disable mousewheel on number inputs
  $("form").on("focus", "input[type=number]", function () {
    $(this).on("wheel.disableScroll", (e) => e.preventDefault());
  });

  $("form").on("blur", "input[type=number]", function () {
    $(this).off("wheel.disableScroll");
  });

  // Bootstrap tooltips
  $("[data-bs-toggle='tooltip']").each(function () {
    new Tooltip(this);
  });

  // Datetime range handling
  //$(".datetimerange").each(function () {
  //  const $this = $(this);
  //  const range1 = $($this.find(".input-group")[0]);
  //  const range2 = $($this.find(".input-group")[1]);
  //
  //  const date1 = range1.data("DateTimePicker")?.date();
  //  const date2 = range2.data("DateTimePicker")?.date();
  //
  //  if (date1) range2.data("DateTimePicker").minDate(date1);
  //  if (date2) range1.data("DateTimePicker").maxDate(date2);
  //
  //  range1.on("dp.change", (e: any) => {
  //    if (e.date) range2.data("DateTimePicker").minDate(e.date);
  //    else range2.data("DateTimePicker").minDate(false);
  //  });
  //
  //  range2.on("dp.change", (e: any) => {
  //    if (e.date) range1.data("DateTimePicker").maxDate(e.date);
  //    else range1.data("DateTimePicker").maxDate(false);
  //  });
  //});
});
